import { createFileRoute } from "@tanstack/react-router";
import { ConnectionsCreateRouteContent } from "./create";

export const Route = createFileRoute("/$owner/connectors/create/$connectorKey")({
	component: ConnectionsCreateConnectorPage,
});

function ConnectionsCreateConnectorPage() {
	const { owner, connectorKey } = Route.useParams();
	return (
		<ConnectionsCreateRouteContent
			owner={owner}
			initialConnectorKey={connectorKey}
		/>
	);
}
